export default __webpack_public_path__ + "static/media/marker-beacon-active.1333a209.svg";